import { useContext } from 'react';
import classNames from 'classnames';
import Checkbox from '../../elements/checkbox';
import Select from '../select';
import Alert from '../../elements/alert';
import { DiagnosticContext } from '../../helpers/functions';
import { getCompetenceLevels } from '../../services/londi-constants';

function SelfAssessmentGroup({ colorClass, name, label, checked, setDisable, setChecked, disabled, error, selectors, innerRef }) {
  const { dispatch } = useContext(DiagnosticContext);

  const handleOnChecked = (e) => {
    if (!e.target.checked) {
      setDisable(true);
      setChecked(false);
      dispatch({ type: `clear${name}` });
    } else {
      setDisable(false);
      setChecked(true);
    }
  };

  return (
    <div ref={innerRef}>
      <Checkbox size="sm" name={name} checked={checked} onChange={handleOnChecked} label={label} />
      {error && <Alert type="error">Alle Felder sind erforderlich</Alert>}
      <div className="grid grid-cols-1 xl:grid-cols-4 gap-1 xl:gap-4">
        {selectors.map(({ link, label, options, type, value, levels }) => (
          <div key={type} className={disabled ? 'pointer-events-none opacity-25' : ''}>
            <Select
              label={
                <a href={link} className={classNames(colorClass, 'underline')} target="_blank" rel="noreferrer">
                  {label}
                </a>
              }
              onToggle={() => dispatch({ type: options })}
              selected={makeOption(getCompetenceLevels)(value?.result)}
              setSelected={(o) => {
                if (o.id > 0) {
                  dispatch({ type: type, payload: o.id });
                }
                setChecked(true);
              }}
              options={Object.values(levels).map(makeOption(getCompetenceLevels))}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

function makeOption(handler) {
  return (v) => {
    if (v == null) return undefined;
    return { id: v, name: handler(v) };
  };
}

export default SelfAssessmentGroup;
